/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';

import LanguageConverterV2 from '@careerstart/wae-common/src/main/helperFunction/LanguageConverterV2';
import { Box, Card, CardContent, Typography } from '@mui/material';

import WaeButton from '../../../../../../components/Button';
import { BLACK, FEED_BACK, PRIMARY_PURPLE } from '../../../../../../theme/colorConstants';
import { PRIMARY_FONT } from '../../../../../../theme/fontConstants';
import {
  epochToDateInReadableFormat,
  epochToDayOfWeek,
  epochToTimeInReadableFormat,
} from '../../../../../../utils';
import { INFRACTION_DISPLAY } from '../../../../UsersConstants';

const generateInfraction = (type) => INFRACTION_DISPLAY[type];
const InfractionCard = ({ infraction, suspensionName, handleOnExcuseOrReinstate }) => (
  <Card
    sx={{
      mb: 2,
      borderRadius: 2,
      border: `1px solid ${BLACK[40]}`,
      elevation: 0,
      boxShadow: 'none',
    }}
  >
    <CardContent>
      <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
        <Box>
          {infraction?.excused && (
            <Typography
              sx={{
                fontSize: '12px',
              }}
            >
              {LanguageConverterV2('userDetail.attendance.excusedBy', {
                reasonType: LanguageConverterV2(generateInfraction(infraction?.infractionType)),
                user: infraction?.excused?.excuserName,
                time: epochToTimeInReadableFormat(infraction?.excused?.time),
                date: epochToDateInReadableFormat(infraction?.excused?.time),
              })}
            </Typography>
          )}
          <Typography
            sx={{
              fontSize: '16px',
              fontFamily: PRIMARY_FONT[500],
              my: 0.5,
            }}
          >
            {LanguageConverterV2('userDetail.attendance.cancelled.time', {
              datOfWeek: epochToDayOfWeek(infraction?.cancelEpoch),
              date: epochToDateInReadableFormat(infraction?.cancelEpoch),
              time: epochToTimeInReadableFormat(infraction?.cancelEpoch),
            })}
          </Typography>
          <Typography
            sx={{
              fontSize: '16px',
            }}
          >
            {infraction?.corpName} - {infraction?.jobName}
          </Typography>
          {infraction?.cancelReason && (
            <>
              <Typography
                sx={{
                  fontSize: '16px',
                  fontFamily: PRIMARY_FONT[500],
                  my: 0.5,
                  pt: 1,
                }}
              >
                {LanguageConverterV2('userDetail.attendance.cancellationReason')}
              </Typography>
              <Typography
                sx={{
                  fontSize: '16px',
                }}
              >
                {infraction?.cancelReason}
              </Typography>
            </>
          )}
        </Box>
        <Box
          sx={{
            width: '117px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
          }}
        >
          <Typography
            sx={{ fontSize: '20px', fontFamily: PRIMARY_FONT[400], color: FEED_BACK.RED_75 }}
          >
            {LanguageConverterV2(generateInfraction(infraction?.infractionType))}
          </Typography>

          {suspensionName && (
            <Typography
              sx={{
                fontSize: '12px',
              }}
            >
              {LanguageConverterV2('userDetail.attendance.appliedTowards', {
                suspensionName: suspensionName || '',
              })}
              {infraction?.expirationOfInfraction &&
                LanguageConverterV2('userDetail.attendance.expirationOfInfraction', {
                  date: epochToDateInReadableFormat(infraction?.expirationOfInfraction),
                })}
            </Typography>
          )}
          <WaeButton
            variant="contained"
            sx={{
              mt: 3,
              width: '100px',
              fontSize: '16px',
              backgroundColor: PRIMARY_PURPLE[70],
              color: 'white',
              fontWeight: 'bold',
              textTransform: 'none',
              '&:hover': { backgroundColor: `${PRIMARY_PURPLE[90]}` },
            }}
            onClick={() => handleOnExcuseOrReinstate(infraction)}
          >
            {infraction?.excused
              ? LanguageConverterV2('userDetail.attendance.reinstate')
              : LanguageConverterV2('userDetail.attendance.excuse')}
          </WaeButton>
        </Box>
      </Box>
    </CardContent>
  </Card>
);

InfractionCard.propTypes = {
  infraction: PropTypes.shape({
    date: PropTypes.number,
    type: PropTypes.string,
    corporation: PropTypes.string,
    title: PropTypes.string,
    cancelNote: PropTypes.string,
  }),
  suspensionName: PropTypes.string,
  handleOnExcuseOrReinstate: PropTypes.func,
};

export default InfractionCard;
